import useActionPermissions from "@src/features/app/hooks/useActionPermissions";
import useIsFullAdmin from "@src/features/app/hooks/useIsFullAdmin";
import { useOrgFeatureFlagsQuery } from "@src/features/app/top-nav/SetOrgFeatureFlags.generated";
import { Ff } from "@src/types.generated";

// Whether this viewer can opt their company into a release early: a full
// Admin who can change org settings, in an org that doesn't have every one of
// the release's flags on yet.
const useCanOptIntoRelease = (flags: Ff[] | undefined): boolean => {
  const isFullAdmin = useIsFullAdmin();
  const { userActionPermissions } = useActionPermissions();
  const eligible =
    !!flags?.length &&
    isFullAdmin &&
    !!userActionPermissions?.changeOrgSettings;
  const { data } = useOrgFeatureFlagsQuery({ skip: !eligible });
  if (!eligible || !data) return false;
  const on = new Set(
    data.OrgFeatureFlags.filter((flag) => flag.enabled).map(
      (flag) => flag.name,
    ),
  );
  return !flags.every((flag) => on.has(flag));
};

export default useCanOptIntoRelease;
